const moduleHome = {
  namespaced: true,
  state: {
    VOTE_ENABLE: false,
    MASK_ACTIVE: true,
    SUBMIT_ENABLE: process.env.VUE_APP_SUBMIT_ENABLE,
    CUR_PAGENUM: sessionStorage.getItem('pagenum') || 1,
    SEASON_INFO: [],
    CUR_SEASON: '',
  },
  mutations: {
    SET_CUR_SEASON: (state, params) => {
      state.CUR_SEASON = params
    },
    SET_SEASON_INFO: (state, params) => {
      state.SEASON_INFO = params
    },
    SET_VOTE_ENABLE: (state, params) => {
      state.VOTE_ENABLE = params
    },
    SET_CUR_PAGENUM: (state, params) => {
      state.CUR_PAGENUM = params
      sessionStorage.setItem('pagenum', params)
    },
    SET_MASK_ACTIVE: (state, params) => {
      state.MASK_ACTIVE = params
    },
  },
  actions: {},
  getters: {
    showTags: (state) => {
      console.log(state.CUR_SEASON)
      return state.CUR_SEASON
        ? new Date() > new Date(state.CUR_SEASON.showStartTime)
        : false
    },
  },
}

export default moduleHome
